import { createSlice } from "@reduxjs/toolkit";

export const adminLoginSlice = createSlice({
  name: "adminLogin",
  initialState: {
    isLoading: false,
    isError: false,
    data: null,
    message: "",
    status_code: null,
  },
  reducers: {
    onAdminLogin: (state) => ({
      ...state,
      isLoading: true,
      isError: false,
      data: null,
      message: "",
      status_code: null,
    }),
    onAdminLoginSuccess: (state, { payload }) => {
      const { data = null, message = "", status_code = 200 } = payload ?? {};
      return {
        ...state,
        isLoading: false,
        isError: false,
        data,
        message,
        status_code: status_code,
      };
    },
    onAdminLoginError: (state, { payload }) => {
      const { data = null, message = "Login failed", status_code = 400 } = payload ?? {};
      return {
        ...state,
        isLoading: false,
        isError: true,
        data,
        message,
        status_code,
      };
    },
    onAdminLoginReset: (state) => ({
      ...state,
      isLoading: false,
      isError: false,
      data: null,
      message: "",
      status_code: null,
    }),
  },
});

export const {
  onAdminLogin,
  onAdminLoginSuccess,
  onAdminLoginError,
  onAdminLoginReset,
} = adminLoginSlice.actions;
export default adminLoginSlice.reducer;
